const buildGradient = (start, end) => `linear-gradient(
    360deg,
    ${start} 2%,
    ${end} 47%
  )`;

const orangeLinear = buildGradient('rgba(181, 46, 0, 1)', 'rgba(255, 129, 25, 1)');

const greyLinear = buildGradient('rgba(76,76,76,1) ', 'rgba(129,129,129,1)');

export const gradients = {
  orangeLinear,
  greyLinear,
};
